import { render, staticRenderFns } from "./MarkdownRenderer.vue?vue&type=template&id=007c77d4&scoped=true"
import script from "./MarkdownRenderer.vue?vue&type=script&lang=js"
export * from "./MarkdownRenderer.vue?vue&type=script&lang=js"
import style0 from "./MarkdownRenderer.vue?vue&type=style&index=0&id=007c77d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007c77d4",
  null
  
)

export default component.exports